import { createServiceCardData } from "../common/serviceCard/createServiceCardData";
import ServiceCardView, {
  IServiceCardData,
} from "../common/serviceCard/card.view";
import { BootstrapSpinner } from "../common/spinners/bootstrapSpinner";
import { useAppSelector } from "../Hooks";

const Landing = () => {

  const roleChooser = useAppSelector(state => state.role);
  const config = useAppSelector(state => state.config);

  function createServiceCards() {
    const serviceCards = createServiceCardData(
      roleChooser.activeRole,
      config.config
    );
    return serviceCards.map((card: IServiceCardData, index: number) => (
      <ServiceCardView key={index} {...card} />
    ));
  }

  if (!roleChooser.loading && roleChooser.roles && !config.loading && config.config) {
    return (
      <div className="container landing-container">
        <h1 className="landing-header">Min side</h1>
        {createServiceCards()}
      </div>
    );
  } else
    return (
      <div className="container">
        <div className="spinner">
          <BootstrapSpinner title="Laster" />
        </div>
      </div>
    );

}

export default Landing;